// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"8c8b9314","89":"c28f48f6","518":"2e4d7452","536":"6729e365","760":"bc8a13ba","820":"474e65b7","857":"607d14e4"}[chunkId] + ".chunk.js";
};